/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ------------------------------
  // 1) Desktop hover → open <details> dropdowns in header
  //    (keeps tap-to-open on touch devices)
  // ------------------------------
  (function setupHoverDropdowns() {
    const mqDesktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const items = document.querySelectorAll('details.menu__item, .menu__item > details');

    if (!items.length) return;

    items.forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      let enterT, leaveT;

      function open() {
        clearTimeout(leaveT);
        enterT = setTimeout(() => {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }, 80); // small delay to avoid flicker
      }

      function close() {
        clearTimeout(enterT);
        leaveT = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 120);
      }

      // Hover open/close (desktop only)
      details.addEventListener('mouseenter', () => { if (mqDesktopHover.matches) open(); });
      details.addEventListener('mouseleave', () => { if (mqDesktopHover.matches) close(); });

      // Prevent summary click toggling on desktop; allow on touch
      summary.addEventListener('click', (e) => {
        if (mqDesktopHover.matches) e.preventDefault();
      });

      // Keyboard: open on focus, close on Esc
      summary.addEventListener('focus', () => { if (mqDesktopHover.matches) open(); });
      details.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
    });
  })();


  // ------------------------------
  // 2) Masonry Grid (blog listing)
  // ------------------------------
  (function setupMasonry() {
    const grid = document.querySelector('.template-blog .grid.blog-listing');
    if (!grid) return; // safe: only exits this block

    const items = Array.from(grid.querySelectorAll('.grid-item'));
    if (!items.length) return;

    // First & last → wide
    items[0].classList.add('wide');
    if (items.length > 1) {
      items[items.length - 1].classList.add('wide');
    }

    // Randomly add "portrait" to others
    for (let i = 1; i < items.length - 1; i++) {
      if (Math.random() < 0.4) {
        items[i].classList.add('portrait');
      }
    }
  })();


  // ------------------------------
  // 3) Header animation (is-scrolled toggle)
  // ------------------------------
  (function setupHeaderAnim() {
    const WRAP = document.querySelector('.header__wrapper');
    if (!WRAP) return;

    const THRESHOLD = 24; // px before swapping
    let isOn = false;

    const set = (on) => {
      if (on === isOn) return;
      isOn = on;
      WRAP.classList.toggle('is-scrolled', on);
    };

    // Prefer IntersectionObserver for smoother behavior near top
    const sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = THRESHOLD + 'px';
    sentinel.style.width = '1px';
    sentinel.style.pointerEvents = 'none';
    (document.body || document.documentElement).prepend(sentinel);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const e = entries[0];
        // When sentinel leaves the viewport top, we’re past threshold
        set(!e.isIntersecting);
      }, { rootMargin: `-${THRESHOLD}px 0px 0px 0px`, threshold: 0 });
      io.observe(sentinel);
    } else {
      // Fallback
      const onScroll = () => set(window.scrollY > THRESHOLD);
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();


  // ------------------------------
  // 4) Collapse first section on journal-tagged pages
  // ------------------------------
  (function setupCollapse() {
    var onReady = function () {
      if (!document.body.classList.contains('is-journal-tagged')) return;

      var first = document.querySelector('.main-content > .shopify-section:first-child');
      if (!first) return;

      // Respect reduced motion
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Set a fixed starting max-height so we can animate to 0
      var h = first.offsetHeight;
      first.style.maxHeight = h + 'px';

      // Kick off the transition
      requestAnimationFrame(function () {
        if (prefersReduced) {
          first.style.maxHeight = '0px';
          first.style.opacity = '0';
          first.style.transform = 'translateY(-8px)';
          first.style.marginTop = '0';
          first.style.marginBottom = '0';
          first.style.paddingTop = '0';
          first.style.paddingBottom = '0';
        } else {
          first.classList.add('is-collapsing');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  })();

  // ------------------------------
  // 5) Blog post sort filters toggle
  // ------------------------------
  const toggle = document.querySelector('.blog__sort-toggle');
  const list = document.querySelector('.inline-nav--sort');

  if (!toggle || !list) return;

  toggle.addEventListener('click', () => {
    const isOpen = list.classList.toggle('open');
    toggle.classList.toggle('active', isOpen);
  });

  // ------------------------------
  // 6) Blog post sort active update
  // ------------------------------
  (function () {
    var list = document.querySelector('.inline-nav--sort');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('li[data-sort]'));

    function getSortFromURL() {
      var params = new URLSearchParams(window.location.search);
      var s = (params.get('sort') || 'featured').toLowerCase();
      return ['featured','newest','oldest'].indexOf(s) > -1 ? s : 'featured';
    }

    function setActive(sort) {
      items.forEach(function (li) {
        li.classList.toggle('inline-nav--active', li.getAttribute('data-sort') === sort);
      });
    }

    // Initial set (on page load)
    setActive(getSortFromURL());

    // Update on back/forward nav
    window.addEventListener('popstate', function () {
      setActive(getSortFromURL());
    });

    // Immediate visual feedback on click (helps with AJAX/pjax themes)
    items.forEach(function (li) {
      var a = li.querySelector('a');
      if (!a) return;
      a.addEventListener('click', function () {
        setActive(li.getAttribute('data-sort'));
      });
    });
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
